import DOMPurify from 'dompurify';
import HTMLReactParser from 'html-react-parser';

interface HtmlParserOptions {
  maxTextLength?: number;
  removeLineBreaks?: boolean;
  removeAllTags?: boolean;
}

export default function HtmlParser(text: string, options?: HtmlParserOptions) {
  let textToSanitize = text;

  if (options?.removeLineBreaks) {
    textToSanitize = textToSanitize
      .replace(new RegExp('<p>', 'g'), '')
      .replace(new RegExp('</p>', 'g'), ' ');
  }

  if (options?.removeAllTags) {
    textToSanitize = textToSanitize.replace(/<\/?[^>]+(>|$)/g, '');
  }

  if (options?.maxTextLength) {
    if (textToSanitize.length > options.maxTextLength - 3) {
      textToSanitize =
        textToSanitize.substring(0, options.maxTextLength - 1) + '...';
    }
  }

  const sanitizedText = DOMPurify.sanitize(textToSanitize);
  return HTMLReactParser(sanitizedText);
}
